<template>
    <div class="form-group" :class="{disabled: disabled}">
        <label 
            :for="id" 
            class="pppp-label"
            :class="{'sr-only': hideLabel}">
            {{ getLabel }}
        </label>
        <HelpButton v-if="help" :id="helpId" :title="helpTitle" />
        <input 
            v-model="value"
            :type="type" 
            :id="id" 
            :name="getName" 
            class="form-control pppp-input" 
            :placeholder="getPlaceholder" 
            :required="required" 
            :disabled="disabled" 
            :maxlength="maxLength" />
        <div v-if="required" class="pppp-validation-msg">
            <span class="glyphicon glyphicon-exclamation-sign"></span> Tämä kenttä on pakollinen!
        </div>
    </div>
</template>

<script>
import HelpButton from './HelpButton.vue';

export default {
    name: 'FormInput',
    components: {
        HelpButton
    },
    props: {
        modelValue: String,
        id:  String,
        name: String,
        type: {
            type: String,
            default: 'text'
        },
        label: String,
        placeholder: String,
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        help: {
            type: Boolean,
            default: false
        },
        helpId: String,
        helpTitle: String,
        hideLabel: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number,
            default: 255
        }
    },
    emits: ['update:modelValue'],
    computed: {
        getLabel() {
            if (this.required) {
                return '* ' + this.label;
            }
            return this.label;
        },
        getPlaceholder() {
            if (this.hideLabel && ! this.placeholder) {
                return this.label;
            }
            return this.placeholder;
        },
        getName() {
            if (! this.name) {
                return this.id;
            }
            return this.name;
        },
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
}
</script>

<style scoped>

</style>
